<script setup>
// Layout das telas da seção IA (ver AI.md).
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  providerWarning: { type: Boolean, default: false },
  wide: { type: Boolean, default: false },
});

// PortVia: IA bloqueada pelo painel administrativo (ex.: falta de pagamento). Ver PATCHES.md.
const { currentAccount } = useAccount();
const isAiBlocked = computed(() => Boolean(currentAccount.value?.ai_blocked));
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <header class="px-6">
      <div class="w-full mx-auto" :class="wide ? 'max-w-7xl' : 'max-w-5xl'">
        <div class="flex items-start justify-between w-full gap-4 pt-6 pb-4">
          <div class="flex flex-col gap-1 min-w-0">
            <h1 class="text-heading-1 text-n-slate-12">{{ title }}</h1>
            <p
              v-if="description"
              class="text-body-para text-n-slate-11 max-w-3xl"
            >
              {{ description }}
            </p>
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <slot name="actions" />
          </div>
        </div>
        <div
          v-if="providerWarning"
          class="flex items-start gap-2 px-4 py-3 mb-2 rounded-xl bg-n-amber-2 outline outline-1 outline-n-amber-5 text-n-amber-11 text-sm"
        >
          <span class="i-lucide-triangle-alert size-4 mt-0.5 shrink-0" />
          <span>{{ $t('AI.PROVIDER_NOT_CONFIGURED') }}</span>
        </div>
        <div
          v-if="isAiBlocked"
          class="flex items-start gap-2 px-4 py-3 mb-2 rounded-xl bg-n-amber-2 outline outline-1 outline-n-amber-5 text-n-amber-11 text-sm"
        >
          <span class="i-lucide-lock size-4 mt-0.5 shrink-0" />
          <span>{{ $t('AI.BLOCKED') }}</span>
        </div>
      </div>
    </header>
    <main class="flex-1 min-h-0 px-6 overflow-y-auto">
      <div
        class="w-full mx-auto py-4"
        :class="wide ? 'max-w-7xl h-full' : 'max-w-5xl'"
      >
        <slot />
      </div>
    </main>
  </section>
</template>
